export const formInitialValues = (data = {}) => ({
    tax_code: data?.tax_code ?? "",
    tax_name: data?.tax_name ?? "",
    type_tax_id: data?.type_tax_id ?? "",
    rate: data?.rate ?? "",
    coa_collect_id: data?.coa_collect_id ?? "",
    coa_paid_id: data?.coa_paid_id ?? "",
    note: data?.note ?? "",
  });
  